import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-open_eye",
  "use": "icon-open_eye-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-open_eye\"><defs><style></style></defs><path d=\"M512 896C182.4 896 46.4 630.4 11.2 548.8c-9.6-24-9.6-49.6 0-73.6C46.4 393.6 182.4 128 512 128c328 0 465.6 265.6 500.8 347.2 9.6 24 9.6 49.6 0 73.6C977.6 630.4 840 896 512 896zM70.4 499.2c-3.2 8-3.2 16 0 24C100.8 596.8 222.4 832 512 832s411.2-235.2 441.6-307.2c3.2-8 3.2-16 0-24C923.2 427.2 801.6 192 512 192S100.8 427.2 70.4 499.2z\" /><path d=\"M512 672c-88 0-160-72-160-160s72-160 160-160 160 72 160 160-72 160-160 160zm0-256c-52.8 0-96 43.2-96 96s43.2 96 96 96 96-43.2 96-96-43.2-96-96-96z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/open_eye.svg
// module id = cATe
// module chunks = 78